import { Screen, StackScreenProps } from '@rahtab/stack-navigator';
import { getSpacing, ListEmpty, Tag, Text } from '@rahtab/ui';
import Button from '@rahtab/ui/dist/components/Button';
import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import BillingCard from './BillingCard';
import { RootStackType } from '../../Router';
import useInvoice from 'hooks/‌Bill/useInvoice';
import useOfficialBillRequest from 'hooks/‌Bill/useOfficialBillRequest';

const PayInfo: React.VFC<PayBillProps> = ({ route }) => {
  const { billCode } = route.params;
  const { data } = useInvoice(billCode);
  const { data: result, loading: tranparentLoading, request } = useOfficialBillRequest(billCode);
  console.log('data', data);
  return (
    <Screen
      title="مشاهده صورت‌حساب"
      data={data}
      transparentLoading={tranparentLoading}
      renderMain={({ id, from, to, items, paidAt, status, statusText, total }) => {
        return (
          <ScrollView style={styles.scrollView}>
            <BillingCard
              id={id}
              from={from}
              to={to}
              items={items}
              total={total}
              caption={
                <View style={styles.rowView}>
                  <Text color="description">
                    زمان پرداخت: <Text>{paidAt}</Text>
                  </Text>
                  {status && <Tag text={statusText} backgroundColor={'green'} color={'white'} />}
                </View>
              }
              // cardAction={
              //   hasOfficialBillRequest ? (
              //     <Button color="secondary" text="درخواست صدور فاکتور رسمی" onPress={request} />
              //   ) : undefined
              // }
            />
          </ScrollView>
        );
      }}
    />
  );
};

export default PayInfo;
type PayBillProps = StackScreenProps<RootStackType, 'PayInfo'>;

const styles = StyleSheet.create({
  rowView: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  scrollView: {
    padding: getSpacing(0.5),
  },
});
